var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElliptical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2819_49468)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 14C15.7909 14 14 15.7909 14 18C14 20.2091 15.7909 22 18 22C20.2091 22 22 20.2091 22 18C22 15.7909 20.2091 14 18 14ZM12 18C12 14.6863 14.6863 12 18 12C21.3137 12 24 14.6863 24 18C24 21.3137 21.3137 24 18 24C14.6863 24 12 21.3137 12 18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18C20 19.1046 19.1046 20 18 20C16.8954 20 16 19.1046 16 18C16 16.8954 16.8954 16 18 16C19.1046 16 20 16.8954 20 18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.52792 14.2654C2.65751 13.7285 3.19777 13.3983 3.73464 13.5279L18.2346 17.0279C18.7715 17.1575 19.1017 17.6978 18.9721 18.2347C18.8425 18.7715 18.3022 19.1017 17.7654 18.9721L3.26536 15.4721C2.72849 15.3425 2.39833 14.8022 2.52792 14.2654Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9906 17.8634C19.0661 18.4105 18.6837 18.9152 18.1366 18.9906L3.63664 20.9906C3.08953 21.0661 2.58484 20.6838 2.50938 20.1366C2.43392 19.5895 2.81626 19.0849 3.36336 19.0094L17.8634 17.0094C18.4105 16.9339 18.9152 17.3163 18.9906 17.8634Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 23C0 22.4477 0.447715 22 1 22H23C23.5523 22 24 22.4477 24 23C24 23.5523 23.5523 24 23 24H1C0.447715 24 0 23.5523 0 23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6961 0.019429C11.2377 0.127741 11.5889 0.654566 11.4806 1.19613L10.6219 5.48936L13.759 7.28199L18.8944 17.5528C19.1414 18.0468 18.9412 18.6474 18.4472 18.8944C17.9532 19.1414 17.3526 18.9412 17.1056 18.4472L12.241 8.71803L8.37807 6.51066L9.51942 0.803894C9.62773 0.262334 10.1546 -0.0888828 10.6961 0.019429Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.53 1.65201C20.9983 1.94472 21.1407 2.56167 20.848 3.03001L18.6125 6.60682L20.9333 12.641C21.1316 13.1565 20.8745 13.7351 20.359 13.9334C19.8435 14.1316 19.2649 13.8745 19.0667 13.359L16.3875 6.3932L19.152 1.97001C19.4447 1.50167 20.0617 1.3593 20.53 1.65201Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2819_49468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElliptical);
export default __webpack_public_path__ + "static/media/elliptical.7f4678470af72a32afdce2415cba40f8.svg";
export { ForwardRef as ReactComponent };